import { uuid } from '@/lib/uuid';

export const getUserID = (): string => {
  let uid = localStorage.getItem('uid');
  if (!uid) {
    uid = `anonymous-${uuid()}`;
  }
  return uid;
};
